import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../components-v2/Theme/theme';

// Header, category rows, and the add row all share these tracks so the column labels line up with the inputs
// they describe. Every track except the name is a fixed width, because an `auto` track resolves against the
// items actually in it: the header has no color picker or delete button, so those tracks would collapse to
// zero there while filling in the rows, and the labels would sit a column adrift. The name takes the rest.
const gridColumns = 'minmax(0, 1fr) 32px 76px 76px 80px';

export const styleSheet = StyleSheet.create({
	addRow: {
		alignItems: 'center',
		borderTop: THEME.common.border,
		display: 'grid',
		gap: THEME.spacing.sm,
		gridTemplateColumns: gridColumns,
		marginTop: THEME.spacing.md,
		paddingTop: THEME.spacing.md,
	},
	addRowButton: {
		gridColumn: '2 / -1',
		justifySelf: 'start',
	},
	confirmActions: {
		display: 'flex',
		flexShrink: 0,
		gap: THEME.spacing.sm,
	},
	confirmMessage: {
		color: THEME.colors.text.main,
		fontSize: THEME.typography.fontSizes.sm,
	},
	// Confirming spans the whole row rather than opening a modal: the legacy confirmation Modal sits at a lower
	// z-index than the components-v2 Dialog this lives inside, so it would render behind the dialog.
	confirmRow: {
		alignItems: 'center',
		display: 'flex',
		gap: THEME.spacing.sm,
		gridColumn: '1 / -1',
		justifyContent: 'space-between',
	},
	emptyState: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.sm,
		padding: `${THEME.spacing.md}px 0`,
	},
	headerCell: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.xs,
		fontWeight: THEME.typography.fontWeights.semibold,
		whiteSpace: 'nowrap',
	},
	headerPerDay: {
		gridColumn: 3,
	},
	headerPerMonth: {
		gridColumn: 4,
	},
	// A maximum is never more than two digits, so the box only needs to look like it holds two.
	maxInput: {
		width: 64,
	},
	nameInput: {
		width: '100%',
	},
	row: {
		alignItems: 'center',
		borderTop: THEME.common.border,
		display: 'grid',
		gap: THEME.spacing.sm,
		gridTemplateColumns: gridColumns,
		padding: `${THEME.spacing.sm}px 0`,
	},
	rowHeader: {
		display: 'grid',
		gap: THEME.spacing.sm,
		gridTemplateColumns: gridColumns,
		paddingBottom: THEME.spacing.xs,
	},
	table: {
		display: 'flex',
		flexDirection: 'column',
	},
});
